import { useMemo, useEffect } from "react";
import { UserAddOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    Form,
    Select,
    Row,
} from "antd";

const { Option } = Select;

export const ClientSectionSlot = ({
    permissions,
    requiredFields,
    loading,
    clients,
    handleClientChange,
    handleAddClient,
    colegios,
    handleColegioChange,
    tpv
}) => {

    const form = Form.useFormInstance();

    const defaultClient = useMemo(() => {
        if (!tpv?.defaultCustomer || !clients) return null;
        return clients.find((client) => client.No === tpv.defaultCustomer);
    }, [clients, tpv?.defaultCustomer]);

    const getRazonSocial = (client) => {
        if (!client) return "";
        if (client.name?.toUpperCase().includes("SAN PEDRO SULA")) {
            return "CONSUMIDOR FINAL SPS";
        }
        if (client.name?.toUpperCase().includes("PUNTO DE VENTA")) {
            return "CONSUMIDOR FINAL";
        }
        return "";
    };

    const onSelectClient = (clientId) => {
        const selected = clients.find(c => c.id === clientId);
        if (selected) {
            form.setFieldValue("Razon_Social", getRazonSocial(selected));
        }
        handleClientChange(clientId);
    };

    useEffect(() => {
        if (defaultClient && form) {
            const currentValue = form.getFieldValue("Sell_to_Customer_No_");
            if (!currentValue) {
                form.setFieldsValue({
                    "Sell_to_Customer_No_": defaultClient.id,
                    "Razon_Social": getRazonSocial(defaultClient)
                });
                handleClientChange(defaultClient.id);
            }
        }
    }, [defaultClient, form, handleClientChange]);

    return (
        <>
            <Row gutter={16}>
                <Col span={permissions?.createClient ? 20 : 24} >
                    <Form.Item
                        name="Sell_to_Customer_No_"
                        label="Cliente"
                        rules={[{ required: requiredFields?.cliente, message: "Seleccione un cliente" }]}
                    >
                        <Select
                            showSearch
                            placeholder="Seleccione un cliente o busque por nombre/DNI"
                            optionFilterProp="children"
                            loading={loading}
                            onChange={onSelectClient}
                            filterOption={(input, option) => {
                                const client = clients.find((c) => c.id === option.value);
                                return (
                                    (option?.label || "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase()) ||
                                    (client?.Numero_Identificacion_fiscal || "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                );
                            }}
                        >
                            {clients?.map((client) => (
                                <Option
                                    key={client.id}
                                    value={client.id}
                                    label={`${client.No || client.id} - ${client.name}${client.Numero_Identificacion_fiscal
                                        ? ` - ${client.Numero_Identificacion_fiscal}`
                                        : ""
                                        }`}
                                >
                                    {client.No || client.id} - {client.name}
                                    {client.Numero_Identificacion_fiscal && (
                                        <span style={{ marginLeft: 8 }}>
                                            Identificador: {client.Numero_Identificacion_fiscal}
                                        </span>
                                    )}
                                    {!client.No && (
                                        <span style={{ color: "#ff4d4f" }}>
                                            {" "}
                                            (Sin sincronizar)
                                        </span>
                                    )}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                {
                    permissions?.createClient ?
                        <Col
                            span={4}
                            style={{
                                display: "flex",
                                alignItems: "end",
                                paddingBottom: "24px",
                            }}
                        >
                            <Button
                                type="primary"
                                icon={<UserAddOutlined />}
                                onClick={handleAddClient}
                                title="Añadir nuevo cliente"
                                style={{ width: "100%" }}
                            />
                        </Col> : null
                }
            </Row>

            <Row gutter={16}>
                <Col xs={24} sm={24}>
                    <Form.Item
                        name="Colegio"
                        label="Colegio"
                        rules={[{ required: requiredFields?.colegio, message: "Seleccione un colegio" }]}
                    >
                        <Select
                            showSearch
                            placeholder="Seleccione un colegio"
                            optionFilterProp="children"
                            loading={loading}
                            allowClear
                            filterOption={(input, option) =>
                                (option?.label || "")
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            onChange={handleColegioChange}
                        >
                            {colegios?.map((colegio) => (
                                <Option
                                    key={colegio.No}
                                    value={colegio.No}
                                    label={`${colegio.No} - ${colegio.nombre}`}
                                >
                                    {colegio.No} - {colegio.nombre}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};
